import React, { PropsWithChildren } from "react";
import {
  Modal,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import {
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  PARAGRAPH_STYLES,
  TYPOGRAPHY,
} from "@dehaat/dds";
import ErrorIcon from "../icons/ErrorIcon";

interface Props {
  showOops?: boolean;
  visible: boolean;
  onClose?: () => void;
  allowClose?: boolean;
  message: string;
  modalStyle?: StyleProp<ViewStyle>;
}

const ErrorModal = ({
  showOops = true,
  visible,
  children,
  onClose,
  message,
  allowClose = true,
  modalStyle,
}: PropsWithChildren<Props>) => {
  return (
    <Modal
      transparent={true}
      visible={visible}
      onRequestClose={() => allowClose && onClose?.()}
    >
      <View style={styles.centeredView}>
        <View style={[styles.modalView, modalStyle]}>
          {allowClose && onClose && (
            <View style={styles.cross}>
              <TouchableOpacity onPress={onClose}>
                <CrossIcon
                  height={25}
                  width={25}
                  fill="none"
                  strokeWidth="1.5"
                  stroke={COLORS.neutral40}
                />
              </TouchableOpacity>
            </View>
          )}
          {showOops && (
            <ErrorIcon
              style={{ width: 56, height: 56 }}
              fill={COLORS.error100}
            />
          )}
          {message ? (
            <Text
              style={[
                PARAGRAPH_STYLES.BoldT1,
                styles.neutral90,
                COMMON_STYLES.mb1,
                COMMON_STYLES.textCenter,
                TYPOGRAPHY.TEXT1,
              ]}
            >
              {message}
            </Text>
          ) : null}
          {children}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    padding: 16,
  },
  modalView: {
    padding: 16,
    width: "100%",
    position: "relative",
    backgroundColor: COLORS.white,
    borderRadius: 12,
    ...COMMON_STYLES.alignItemsCenter,
    maxWidth: 600,
  },
  cross: {
    flexDirection: "row",
    justifyContent: "flex-end",
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: -14.5,
    marginRight: 16,
    backgroundColor: COLORS.white,
    borderRadius: 999,
    elevation: 1,
    padding: 4,
  },
  neutral90: {
    color: COLORS.neutral90,
  },
});

export default ErrorModal;
